export interface StageLike {
  id: string;
}

/** The stage a candidate advances to: the next in sorted order, or null at the
 *  end or when the next stage is the archived stage. Mirrors the logic in
 *  profile.tsx / bulk-actions.tsx. */
export function nextStageId(
  sortedStages: StageLike[],
  currentStageId: string,
  archivedStageId?: string | null,
): string | null {
  const idx = sortedStages.findIndex((s) => s.id === currentStageId);
  if (idx < 0 || idx >= sortedStages.length - 1) return null;
  const next = sortedStages[idx + 1];
  if (archivedStageId && next.id === archivedStageId) return null;
  return next.id;
}

export interface CandidateLike {
  job_candidate_id: string;
  stage_id: string;
}

/** Build promote/preflight moves for a set of gated ids. With `target`
 *  (bulk-move) every move targets it; otherwise (advance) each targets its own
 *  next stage. Candidates with no resolvable next stage are skipped. */
export function buildMoves(
  ids: string[],
  candidates: CandidateLike[],
  sortedStages: StageLike[],
  archivedStageId: string | null,
  target?: string | null,
): { job_candidate_id: string; target_stage_id: string }[] {
  const byId = new Map(candidates.map((c) => [c.job_candidate_id, c]));
  const moves: { job_candidate_id: string; target_stage_id: string }[] = [];
  for (const id of ids) {
    if (target) {
      moves.push({ job_candidate_id: id, target_stage_id: target });
      continue;
    }
    const c = byId.get(id);
    if (!c) continue;
    const next = nextStageId(sortedStages, c.stage_id, archivedStageId);
    if (next) moves.push({ job_candidate_id: id, target_stage_id: next });
  }
  return moves;
}
